<template>
    <div>
        <h1 class="mb-3">抖音团购</h1>
        <Card style="width: 1100px">
            <Tabs @on-click="changeTab" v-model="tabIndex" type="card">
                <TabPane name="抖音团购" label="抖音团购">
                    <Form @submit.native.prevent style="display: flex; justify-content: flex-end" inline>
                        <FormItem>
                            <Checkbox v-model="isuseTime">只搜索使用时间内商品</Checkbox>
                        </FormItem>
                        <FormItem prop="">
                            <Input placeholder="商品名称搜索" v-model="name" />
                        </FormItem>
                        <Button class="mr-2" @click="() => fetTableShopping(tableShoppingData.page, name)">搜索</Button>
                        <Button type="error" @click="showSomeModal">同步数据</Button>
                    </Form>
                    <Table size="small" :columns="tableShoppingData.title" :data="tableShoppingData.list">
                        <template slot-scope="{ row }" slot="openCash">
                            <i-Switch @on-change="(value) => destoryCode(row._id, value)" :value="row.openCash"></i-Switch>
                        </template>
                        <template slot-scope="{ row }" slot="givList">
                            <Button @click="() => showSettingModel(row)" size="small">{{ row.givList }}</Button>
                        </template>
                        <template slot-scope="{ row }" slot="isConfigVerifRule">
                            <Button @click="dyWriteOff('已配置', row._id)" v-if="row.isConfigVerifRule" size="small">已配置</Button>
                            <Button @click="dyWriteOff('未配置', row._id)" v-else size="small">未配置</Button>
                        </template>

                        <template slot-scope="{ row }" slot="online_status">
                            <Tag v-if="row.online_status == '在线'" type="dot" color="success">在线</Tag>
                            <Tag v-if="row.online_status == '导入'" color="success" type="dot">导入</Tag>
                            <Tag v-if="row.online_status == '下线'" type="dot">下线</Tag>
                        </template>
                        <template slot-scope="{ row }" slot="Note">
                            <div class="text-red-500">{{ row.Note }}</div>
                        </template>
                    </Table>
                    <div class="text-right">
                        <Page :page-size="tableShoppingData.size" :total="tableShoppingData.total" @on-change="fetTableShopping"></Page>
                    </div>
                </TabPane>
                <TabPane name="手动导入" label="手动导入">
                    <div class="flex justify-end mb-3">
                        <Form @submit.native.prevent :disabled="xlslTableList.length > 0" inline>
                            <FormItem>
                                <Upload :show-upload-list="false" :before-upload="handleUpload" multiple action="//jsonplaceholder.typicode.com/posts/">
                                    <Button>本地导入</Button>
                                </Upload>
                            </FormItem>
                        </Form>
                        <Button class="mr-2" @click="() => downTemplate()">下载模版</Button>
                        <Button class="mr-2" :disabled="xlslTableList.length >= 20" @click="showdyModalAdd">添加</Button>
                        <Button @click="xlslTableList = []">清空导入表格</Button>
                    </div>
                    <Table :columns="xlslTableHeader" :data="xlslTableList">
                        <template slot-scope="{ row }" slot="exeType">
                            <div v-if="row.exeType == '导入异常'" class="text-red-500">{{ row.exeType }}</div>
                            <div v-else>{{ row.exeType }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="result">
                            <div v-if="row.result == '成功'" class="text-green-400">{{ row.result }}</div>
                            <div v-else class="text-red-500">{{ row.result }}</div>
                        </template>
                    </Table>
                    <div class="mt-3 text-right">
                        <Button @click="uploadTableData" v-if="xlslTableList.length > 0">确认上传</Button>
                    </div>
                </TabPane>

                <TabPane name="微信核销记录" label="微信核销记录">
                    <div class="flex justify-end">
                        <Form @submit.native.prevent ref="formPayCode" :model="formPayCode" :rules="ruleFormPayCode" inline>
                            <FormItem prop="startTime">
                                <DatePicker
                                    transfer
                                    v-model="formPayCode.startTime"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm"
                                    placeholder="核销开始时间"
                                    style="width: 200px"
                                ></DatePicker>
                            </FormItem>
                            <FormItem prop="endTime">
                                <DatePicker
                                    transfer
                                    v-model="formPayCode.endTime"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm"
                                    placeholder="核销结束时间"
                                    style="width: 200px"
                                ></DatePicker>
                            </FormItem>
                            <FormItem prop="dycode">
                                <Input v-model="formPayCode.dycode" placeholder="团购码" />
                            </FormItem>
                            <FormItem prop="orderid">
                                <Input v-model="formPayCode.orderid" placeholder="团购订单号" />
                            </FormItem>
                            <FormItem>
                                <Button @click="() => fetchPayCodeTableData()">查询</Button>
                            </FormItem>
                            <FormItem>
                                <Button @click="exportPayCodeTable" type="primary">导出</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <Table size="small" :columns="payCodeTableData.title" :data="payCodeTableData.list">
                        <template slot-scope="{ row }" slot="revoke">
                            <Tag v-if="row.revoke == '已撤销'">{{ row.revoke }}</Tag>
                            <Tag v-if="row.revoke == '已核销'" color="cyan">{{ row.revoke }}</Tag>
                        </template>
                        <template slot-scope="{ row }" slot="isRelieve_res">
                            <div style="font-size: 3px">{{ row.isRelieve_res }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="opreate">
                            <Button v-if="row.revoke == '已核销' && row.isRevoke" type="error" size="small" @click="() => handleBackupBtn(row)">撤销</Button>
                            <Button @click="() => openWindow(row._id)" size="small">详情</Button>
                        </template>
                    </Table>
                    <div class="text-right">
                        <Page :page-size="payCodeTableData.size" :total="payCodeTableData.total" @on-change="fetchPayCodeTableData"></Page>
                    </div>
                </TabPane>

                <TabPane name="抖音在线核销记录" label="抖音在线核销记录">
                    <div class="flex justify-end mb-3">
                        <Form @submit.native.prevent inline>
                            <FormItem>
                                <DatePicker
                                    transfer
                                    format="yyyy-MM-dd HH:mm"
                                    type="datetimerange"
                                    placeholder="请选择开始时间和结束时间"
                                    style="width: 300px"
                                    :value="useRecord"
                                    @on-change="changeUseRecodeDatePicker"
                                ></DatePicker>
                            </FormItem>
                            <FormItem>
                                <Input placeholder="抖音团购单号" v-model="dyOrderid" />
                            </FormItem>
                        </Form>
                        <Button @click="searchUseRecord()">查询</Button>
                    </div>
                    <Table :columns="useRecordData.title" :data="useRecordData.list">
                        <template slot-scope="{ row }" slot="exeType">
                            <div v-if="row.exeType == '导入异常'" class="text-red-500">{{ row.exeType }}</div>
                            <div v-else>{{ row.exeType }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="result">
                            <div v-if="row.result == '成功'" class="text-green-400">{{ row.result }}</div>
                            <div v-else class="text-red-500">{{ row.result }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="operater">
                            <Button @click="() => routeTo('orderDetail?id=' + row.orderid)" size="small">详情</Button>
                        </template>
                    </Table>
                    <div class="text-right">
                        <Page
                            :page-size="useRecordData.size"
                            :total="useRecordData.total"
                            @on-change="(value) => searchUseRecord(value, useRecordData.size)"
                        ></Page>
                    </div>
                    <div class="mt-3 text-right">
                        <Button @click="uploadTableData" v-if="xlslTableList.length > 0">确认上传</Button>
                    </div>
                </TabPane>
                <TabPane name="EVO取货" label="EVO取货">
                    <Form @submit.native.prevent inline>
                        <FormItem label="EOV取货码" label-width="100">
                            <Input style="width: 200px" v-model="evoCode" @keyup.enter.native="searchEVO" />
                        </FormItem>
                        <FormItem>
                            <Button @click="searchEVO" type="primary">查询</Button>
                        </FormItem>
                    </Form>
                    <div v-if="evoData" style="padding: 30px 20px">
                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>订单号：</div>
                            <div>{{ evoData.orderid }}</div>
                        </div>

                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>订单状态：</div>
                            <div>{{ evoData.state }}</div>
                        </div>
                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>交易时间：</div>
                            <div>{{ evoData.payTime }}</div>
                        </div>
                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>取货状态：</div>
                            <div v-if="evoData.getGoodsStatus" style="color: green">已取货</div>
                            <div v-else>未取货</div>
                        </div>
                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>取货时间：</div>
                            <div>{{ evoData.getGoodsTime }}</div>
                        </div>

                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>抖音订单号：</div>
                            <div>{{ evoData.dy_orderid }}</div>
                        </div>
                        <div style="display: flex; padding-left: 10px; border-left: 2px solid; margin-bottom: 3px">
                            <div>用户手机：</div>
                            <div>{{ evoData.phoneNumber }}</div>
                        </div>

                        <div style="padding-left: 10px; border-left: 2px solid; margin-top: 30px; margin-bottom: 10px">商品列表</div>
                        <Table
                            :columns="[
                                {
                                    key: 'icon',
                                    title: '图标',
                                    slot: 'icon',
                                },
                                {
                                    key: 'name',
                                    title: '商品名称',
                                },
                                {
                                    key: 'quantity',
                                    title: '数量',
                                },

                                {
                                    key: 'exchangeType',
                                    title: '核销方式',
                                },
                            ]"
                            :data="evoData.goodsList"
                        >
                            <template slot-scope="{ row, index }" slot="icon">
                                <img style="width: 50px" :src="row.icon" />
                            </template>
                        </Table>
                        <div style="margin-top: 20px; text-align: right">
                            <Button @click="modalConfirmPickUpGoods = true" v-if="!evoData.getGoodsStatus" type="primary">确认取货</Button>
                            <Poptip transfer trigger="hover" title="交易日志" :content="evoData.failureInfos">
                                <Button v-if="evoData.isDropGoods" style="margin-left: 10px">交易日志</Button>
                                <div slot="content">
                                    <pre>{{ evoData.failureInfos }}</pre>
                                </div>
                            </Poptip>
                        </div>
                    </div>
                </TabPane>
            </Tabs>
        </Card>
        <Modal v-model="modalConfirmPickUpGoods" title="" @on-ok="confirmPickUpGoods" @on-cancel="modalConfirmPickUpGoods = false">
            <div>确认是否收货？</div>
        </Modal>
        <Modal title="兑换表编辑" width="700" :mask="false" v-model="settingModel" :closable="false">
            <Form @submit.native.prevent :label-width="100">
                <FormItem label="商品ID">
                    <Input disabled v-model="currentTableRow.sku_id" />
                </FormItem>
                <FormItem label="商品名称">
                    <Input disabled v-model="currentTableRow.sku_name" />
                </FormItem>
                <Row>
                    <Col :span="12">
                        <FormItem label="状态">
                            <Input disabled v-model="currentTableRow.online_status" />
                        </FormItem>
                    </Col>
                    <Col :span="12">
                        <FormItem label="类型">
                            <Input disabled v-model="currentTableRow.product_type" />
                        </FormItem>
                    </Col>
                </Row>
                <FormItem label="销售时间">
                    <Input disabled :value="`${currentTableRow.start_time}至${currentTableRow.end_time}`" />
                </FormItem>
                <FormItem label="使用时间">
                    <Input disabled :value="currentTableRow.use_time_str" />
                </FormItem>
            </Form>
            <Form @submit.native.prevent :label-width="10" ref="formPreset" :model="formPreset" :rules="ruleFormPreset">
                <Row>
                    <Col :span="7">
                        <FormItem prop="value1" :label-width="30">
                            <Select placeholder="请选择票券" v-model="formPreset.value1">
                                <Option v-for="(item, index) in presetValue" :key="index" :value="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col :span="7">
                        <FormItem prop="value2">
                            <Input type="number" placeholder="兑换量" v-model.number="formPreset.value2" />
                        </FormItem>
                    </Col>
                    <Col :span="7">
                        <FormItem prop="value3">
                            <Input type="number" placeholder="有效期" v-model.number="formPreset.value3" />
                        </FormItem>
                    </Col>
                    <Col :span="3">
                        <FormItem>
                            <Button @click="insetTableData" type="primary">插入</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Alert show-icon>有效期填写:抖音商品使用时间(-1);票券申请单有效期(0);绑定时间+有效期动态生成(大于0)</Alert>
            <Table :columns="title" :data="currentTableRow.givList" size="small">
                <template slot-scope="{ row, index }" slot="operater">
                    <Button type="error" size="small" @click="() => removeInsetTableRow(index)">删除</Button>
                </template>
            </Table>

            <div slot="footer">
                <Button @click="() => cancelSettingModal()">取消</Button>
                <Button v-if="$my_checkBtn('settingchange')" type="primary" @click="confimSettingModal">确定</Button>
            </div>
        </Modal>
        <Modal :mask="false" :closable="false" v-model="backupModel">
            <h1>撤销原因</h1>
            <Alert show-icon>撤销核销并非团购退款，只是将团购码撤销为未核销状态，退款请到抖音来客后台操作</Alert>
            <Form @submit.native.prevent ref="backupForm" :model="backupForm" :rules="ruleBackupForm">
                <FormItem prop="note">
                    <Input :rows="3" type="textarea" v-model="backupForm.note" />
                </FormItem>
                <FormItem label="" prop="isRelieve"> <Checkbox v-model="backupForm.isRelieve"></Checkbox>回收销毁 已发放票券 </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelBackUpModal">返回</Button>
                <Button type="primary" @click="confirmBackUp">确认</Button>
            </div>
        </Modal>
        <Modal title="同步数据" :mask="false" :closable="false" v-model="someModal">
            <Form @submit.native.prevent ref="someModalref" :label-width="100" class="w-80" :model="someModalForm" :rules="someModalRules">
                <FormItem prop="select" label="选择同操作">
                    <Select v-model="someModalForm.select">
                        <Option value="同步全部上线商品">同步全部上线商品</Option>
                        <Option value="同步单个商品">同步单个商品</Option>
                    </Select>
                </FormItem>
                <FormItem prop="product_id" label="抖音商品ID" v-if="someModalForm.select == '同步单个商品'">
                    <Input v-model="someModalForm.product_id" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="() => cancelSomeModal()">取消</Button>
                <Button type="primary" @click="() => confirmSomeModal()">确定</Button>
            </div>
        </Modal>
        <Modal title="添加" :mask="false" v-model="dyTableUploadModal" :closable="false">
            <Form @submit.native.prevent class="w-96" ref="uploadForm" :model="uploadForm" :rules="uploadFormRules" :label-width="120">
                <FormItem prop="sku_id" label="商品ID">
                    <Input v-model="uploadForm.sku_id" />
                </FormItem>
                <FormItem prop="sku_name" label="商品名称">
                    <Input v-model="uploadForm.sku_name" />
                </FormItem>
                <FormItem prop="start_time" label="售卖时间(开始)">
                    <Input v-model="uploadForm.start_time" />
                </FormItem>
                <FormItem prop="end_time" label="售卖时间(结束)">
                    <Input v-model="uploadForm.end_time" />
                </FormItem>
                <FormItem prop="use_start_time" label="使用时间(开始)">
                    <Input v-model="uploadForm.use_start_time" />
                </FormItem>
                <FormItem prop="use_end_time" label="使用时间(结束)	">
                    <Input v-model="uploadForm.use_end_time" />
                </FormItem>
                <FormItem prop="exeType"></FormItem>
            </Form>
            <div slot="footer">
                <Button @click="dyTableUploadModal = false">取消</Button>
                <Button @click="confirmAddTableRow" type="primary">确定</Button>
            </div>
        </Modal>
        <Modal width="1000" title="抖音核销" :mask="false" v-model="dyWriteOffModal" :closable="false">
            <Form @submit.native.prevent ref="writeOff" :model="uploadForm" :label-width="130" style="width: 900px">
                <FormItem prop="skuId" label="商品ID">
                    <Input :disabled="true" v-model="writeOffData.skuId" />
                </FormItem>
                <FormItem prop="skuName" label="商品名称">
                    <Input :disabled="true" v-model="writeOffData.skuName" />
                </FormItem>
                <FormItem prop="skuType" label="商品类型">
                    <Input :disabled="true" v-model="writeOffData.skuType" />
                </FormItem>
                <FormItem prop="updatedAt" label="更新时间">
                    <Input :disabled="true" v-model="writeOffData.updatedAt" />
                </FormItem>
                <FormItem prop="status" label="状态">
                    <i-Switch v-model="writeOffData.status"></i-Switch>
                </FormItem>

                <!--<Tabs @on-click="changeTab" v-model="tabIndex" type="card">-->
                <Tabs v-model="modalTabIndex" type="card">
                    <TabPane name="电影票" label="电影票">
                        <div style="display: flex">
                            <div style="flex: 1">
                                <FormItem prop="movieCount" label="电影票数量">
                                    <InputNumber :min="0" v-model="writeOffData.movieCount" />
                                </FormItem>
                                <div style="display: flex; justify-content: space-between">
                                    <FormItem prop="moviePrice" label="电影票单价">
                                        <InputNumber :min="0" v-model="writeOffData.moviePrice" />
                                    </FormItem>
                                    <div style="text-align: right">
                                        <Button
                                            v-if="writeOffData.movieRule"
                                            :disabled="writeOffData.movieRule.length >= 20"
                                            @click="showModalRuleAdd"
                                            style="margin-left: 10px"
                                            >添加规则{{ writeOffData.movieRule.length }}/20</Button
                                        >
                                        <div v-if="writeOffData.movieRule" style="display: flex; margin-top: 10px">
                                            <div style="margin-right: 10px">默认允许兑换</div>
                                            <i-Switch v-model="writeOffData.movieRuleElse" :disabled="writeOffData.movieRule.length == 0"></i-Switch>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table :columns="movieRuleTitle" :data="writeOffData.movieRule" size="small">
                            <template slot-scope="{ row, index }" slot="detail">
                                <Poptip transfer trigger="hover" placement="left">
                                    <div>显示更多</div>
                                    <div class="api" slot="content">
                                        <div v-if="row.ruleType == 'hall'">
                                            <div v-for="item in row.hallCodeList">
                                                {{ ruleTypeList.find((item1) => item1.value == 'hall').children.find((item2) => item2.value == item).label }}
                                            </div>
                                        </div>
                                        <div v-if="row.ruleType == 'week'">
                                            <div v-for="item in row.weekList">
                                                {{ ruleTypeList.find((item1) => item1.value == 'week').children.find((item2) => item2.value == item).label }}
                                            </div>
                                        </div>
                                        <div v-if="row.ruleType == 'time' && row.format == 'time'">
                                            <div>开始时间:{{ row.startTime }}</div>
                                            <div>结束时间:{{ row.endTime }}</div>
                                        </div>

                                        <div v-if="row.ruleType == 'time' && row.format == 'datetime'">
                                            <div>开始时间:{{ row.startTime }}</div>
                                            <div>结束时间:{{ row.endTime }}</div>
                                        </div>

                                        <div v-if="row.ruleType == 'time' && row.format == 'dates'">
                                            <div v-for="item in row.dateList">{{ item }}</div>
                                        </div>
                                        <div v-if="row.ruleType == 'movie'">
                                            <div v-for="item in row.movieList">
                                                <div>{{ item.movieName }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Poptip>
                            </template>
                            <template slot-scope="{ row, index }" slot="isExchange">
                                <div v-if="row.isExchange" style="color: green">允许</div>
                                <div v-else style="color: red">不允许</div>
                            </template>
                            <template slot-scope="{ row, index }" slot="ruleType">
                                <div>{{ ruleTypeList.find((item) => item.value == row.ruleType).label }}</div>
                            </template>

                            <template slot-scope="{ row, index }" slot="operater">
                                <Button type="error" size="small" @click="() => deleteRuleAdd(index)">删除</Button>
                                <Button style="margin-left: 10px" type="primary" size="small" @click="() => editRuleAdd(row, index)">编辑</Button>
                            </template>
                        </Table>
                    </TabPane>

                    <TabPane name="卖品套餐" label="卖品套餐">
                        <!--todo-->
                        <div style="flex: 1">
                            <FormItem prop="goodsExchange" label="兑换方式">
                                <Select style="width: 185px" v-model="writeOffData.goodsExchange">
                                    <Option value="取餐码">取餐码</Option>
                                    <Option value="小程序兑换券">小程序兑换券</Option>
                                    <Option value="手工核销">手工核销</Option>
                                </Select>
                            </FormItem>
                            <div style="display: flex">
                                <FormItem prop="goodsExchange" label="商品查找">
                                    <Select v-model="model13" filterable :remote-method="remoteMethod1" :loading="loading1">
                                        <Option v-for="(option, index) in options1" :value="option" :key="index">{{ option.label }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem prop="goodsCount" label="商品数量">
                                    <InputNumber :min="0" v-model="model13.goodsCount" />
                                </FormItem>
                                <FormItem prop="" label="">
                                    <Button @click="add2GoodsList">添加</Button>
                                </FormItem>
                            </div>
                        </div>
                        <Table :columns="titleGoods" :data="writeOffData.goodsList" size="small">
                            <template slot-scope="{ row, index }" slot="goodsIcon">
                                <img style="width: 80px; height: 50px" :src="row.goodsIcon" />
                            </template>
                            <template slot-scope="{ row, index }" slot="goodsPrice">
                                <InputNumber :min="0" v-model="writeOffData.goodsList[index].goodsPrice" />
                            </template>
                            <template slot-scope="{ row, index }" slot="goodsCount">
                                <InputNumber :min="0" v-model="writeOffData.goodsList[index].goodsCount" />
                            </template>
                            <template slot-scope="{ row, index }" slot="totalPrice">
                                {{ row.goodsPrice * row.goodsCount }}
                            </template>

                            <template slot-scope="{ row, index }" slot="operater">
                                <Button type="error" size="small" @click="() => removeInsetTableRow2(index)">删除</Button>
                            </template>
                        </Table>
                        <!--todo-->
                    </TabPane>
                </Tabs>
                <h2>总价：￥{{ cpTotalPrice.toFixed(2) }}(电影票总价:{{ cpMv.toFixed(2) }}商品总价:{{ cpGoods.toFixed(2) }})</h2>
            </Form>
            <div slot="footer">
                <Button @click="hideMe">取消</Button>
                <Button @click="confirmWriteOff" type="primary">确定</Button>
            </div>
        </Modal>
        <Modal title="添加规则" :mask="false" v-model="modalRuleAdd" :closable="false">
            <div>
                <Form @submit.native.prevent ref="formRuleType" :label-width="80">
                    <FormItem prop="weight" label="优先级">
                        <InputNumber v-model="formRuleType.weight" max="100" min="0" />
                    </FormItem>
                    <FormItem prop="isExchange" label="允许兑换">
                        <i-Switch v-model="formRuleType.isExchange" />
                    </FormItem>
                    <FormItem prop="ruleType" label="规则类型">
                        <RadioGroup button-style="solid" type="button" v-model="formRuleType.ruleType">
                            <Radio v-for="item in ruleTypeList" :label="item.value">
                                <span>{{ item.label }}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem v-if="formRuleType.ruleType == 'week'" prop="week" label="星期">
                        <Select multiple style="width: 260px" v-model="formRuleType.week">
                            <Option v-for="item in ruleTypeList.find((item1) => item1.value == 'week').children" :value="item.value" :key="item.value">{{
                                item.label
                            }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem v-if="formRuleType.ruleType == 'hall'" prop="hall" label="影厅">
                        <Select multiple style="width: 260px" v-model="formRuleType.hall">
                            <Option v-for="item in ruleTypeList.find((item1) => item1.value == 'hall').children" :value="item.value" :key="item.value">{{
                                item.label
                            }}</Option>
                        </Select>
                    </FormItem>
                    <div v-show="formRuleType.ruleType == 'movie'">
                        <Alert show-icon>输入影片名称，搜索影片</Alert>
                        <FormItem label="选择影片">
                            <Select
                                ref="select"
                                placeholder="请输入片名"
                                v-model="formRuleType.movieList"
                                multiple
                                filterable
                                :remote-method="remoteMethod2"
                                :loading="loading2"
                            >
                                <Option v-for="(option, index) in options2" :value="option.value" :key="index">{{ option.label }}</Option>
                            </Select>
                        </FormItem>
                    </div>
                    <div v-if="formRuleType.ruleType == 'time'">
                        <RadioGroup style="margin-left: 80px" button-style="solid" type="button" v-model="formRuleType.format">
                            <Radio
                                v-for="item in ruleTypeList.find((item) => item.value == 'time').children.find((item1) => item1.key == 'format').value"
                                :label="item.value"
                            >
                                <span>{{ item.label }}</span>
                            </Radio>
                        </RadioGroup>
                        <div style="display: flex; margin-top: 10px" v-if="formRuleType.format == 'time'">
                            <FormItem label="范围">
                                <TimePicker v-model="formRuleType.startTime" type="time" placeholder="开始时间" style="width: 120px"></TimePicker>
                            </FormItem>
                            <FormItem label-width="0" style="margin-left: 10px">
                                <TimePicker v-model="formRuleType.endTime" type="time" placeholder="结束时间" style="width: 120px"></TimePicker>
                            </FormItem>
                        </div>
                        <div style="display: flex; margin-top: 10px" v-if="formRuleType.format == 'datetime'">
                            <FormItem label="范围">
                                <DatePicker v-model="formRuleType.startTime1" type="datetime" placeholder="开始日期" style="width: 180px"></DatePicker>
                            </FormItem>
                            <FormItem label-width="0" style="margin-left: 10px">
                                <DatePicker v-model="formRuleType.endTime1" type="datetime" placeholder="结束日期" style="width: 180px"></DatePicker>
                            </FormItem>
                        </div>
                        <div v-if="formRuleType.format == 'dates'">
                            <div style="display: flex; margin-top: 10px">
                                <FormItem label="">
                                    <DatePicker v-model="formRuleType.dates" type="date" placeholder="日期" style="width: 120px"></DatePicker>
                                </FormItem>
                                <FormItem label="">
                                    <Button @click="add2Dates">添加</Button>
                                    <Button style="margin-left: 10px" @click="add2DatesFromhHoliday">导入节假日</Button>
                                </FormItem>
                            </div>
                            <Table
                                :columns="[
                                    { title: '日期', key: 'date' },
                                    { title: 'operater', title: '操作', slot: 'operater' },
                                ]"
                                :data="formRuleType.dateList"
                                size="small"
                            >
                                <template slot-scope="{ row, index }" slot="operater">
                                    <Button type="error" size="small" @click="removeSpacelDate(index)">删除</Button>
                                </template>
                            </Table>
                        </div>
                    </div>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="hideMe('modalRuleAdd')">取消</Button>
                <Button @click="confirmModalRuleAdd" type="primary">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import {
    GetTiktokShopList,
    GetDyGoosList,
    ExeDyGoos,
    GetPresetValue,
    GetGoosCashRecordList,
    GetGoosCashRecordInfo,
    RevokeCash,
    GetTiktokShop,
    CheckmanualEdit,
    ManualEdit,
    GetDyVerifRule,
    SetDyVerifRule,
    GetDyVerifGoodsList,
    GetDyVerifRecord,
    OperationHoliday,
    ConfirmEovCode,
    QueryEovCodeInfo,
} from '@/request/api';
import { CellGroup, Checkbox, FormItem, Input, Time } from 'view-design';
import { download } from '@/utils/table_download.js';
import { readXls2Json } from '../../../utils/table_download';
import moment from 'moment';
import axios from 'axios';

export default {
    name: 'dyShopping',
    data() {
        return {
            modalRuleType: '',
            dates: '',
            loading2: false,
            model14: [],
            options2: [],
            movieRuleTitle: [
                { key: 'weight', title: '优先级' },
                { key: 'isExchange', title: '允许兑换', slot: 'isExchange' },
                { key: 'ruleType', title: '规则类型', slot: 'ruleType' },
                { key: 'detail', title: '详情', slot: 'detail' },
                { key: 'operater', title: '操作', slot: 'operater' },
            ],
            ruleTypeList: [],
            formRuleType: {
                weight: '1',
                isExchange: '',
                ruleType: '',
                week: [],
                hall: [],
                format: '',
                startTime: '',
                startTime1: '',
                endTime: '',
                endTime1: '',
                dateList: [],
                dates: '',
                movieList: [],
            },
            ruleTypeList: [
                {
                    value: 'New York',
                    label: 'New York',
                },
            ],
            modalRuleAdd: false,
            modalTabIndex: '电影票',
            tabIndex: '抖音团购',
            tableShoppingData: '',
            name: '',
            settingModel: false,
            currentTableRow: '',
            title: [
                { key: 'type', title: '类型' },
                { key: 'Name', title: '名称' },
                { key: 'Num', title: '数量' },
                { key: 'Time', title: '有效期' },
                { key: 'operater', title: '操作', slot: 'operater' },
            ],
            presetValue: [],
            formPreset: {
                value1: '',
                value2: '',
                value3: '',
            },
            ruleFormPreset: {
                value1: { required: 'true', trigger: 'blur' },
                value2: { required: 'true', trigger: 'blur', type: 'number' },
                value3: { required: 'true', trigger: 'blur', type: 'number' },
            },
            formPayCode: {
                startTime: new Date().Format('yyyy-MM-dd') + ' 06:00',
                endTime: new Date(new Date(Date.now() + 1000 * 24 * 60 * 60)).Format('yyyy-MM-dd') + ' 06:00',
                dycode: '',
                orderid: '',
            },
            ruleFormPayCode: {},
            payCodeTableData: {},
            backupForm: {
                isRelieve: true,
                note: '',
            },
            ruleBackupForm: {
                note: { required: true, trigger: 'blur', message: ' ' },
                isRelieve: { required: true, trigger: 'blur', message: ' ', type: 'boolean' },
            },
            backupModel: false,
            isuseTime: true,
            someModalSelectBind: '',
            someModalForm: {
                product_id: '',
                select: '同步全部上线商品',
            },
            someModalRules: {
                select: { require: true, trigger: 'blur', message: ' ' },
                product_id: { require: true, trigger: 'blur', message: ' ' },
            },
            someModal: false,
            xlslTableHeader: [
                {
                    title: '商品ID',
                    key: 'sku_id',
                },
                {
                    title: '商品名称',
                    key: 'sku_name',
                },
                {
                    title: '售卖时间(开始)',
                    key: 'start_time',
                },
                {
                    title: '售卖时间(结束)',
                    key: 'end_time',
                },
                {
                    title: '使用时间(开始)',
                    key: 'use_start_time',
                },
                {
                    title: '使用时间(结束)',
                    key: 'use_end_time',
                },
                {
                    title: '导入类型',
                    key: 'exeType',
                    slot: 'exeType',
                },
                {
                    title: '执行结果',
                    key: 'result',
                    slot: 'result',
                },
            ],
            xlslTableList: [],
            dyTableUploadModal: false,
            uploadForm: {
                exeType: '',
                sku_id: '',
                sku_name: '',
                start_time: '',
                end_time: '',
                use_end_time: '',
                use_start_time: '',
            },
            uploadFormRules: {
                sku_id: { required: 'true', trigger: 'blur', message: ' ' },
                sku_name: { required: 'true', trigger: 'blur', message: ' ' },
                start_time: { required: 'true', trigger: 'blur', message: ' ' },
                end_time: { required: 'true', trigger: 'blur', message: ' ' },
                use_end_time: { required: 'true', trigger: 'blur', message: ' ' },
                use_start_time: { required: 'true', trigger: 'blur', message: ' ' },
            },
            writeOffData: '',
            dyWriteOffModal: false,
            model13: '',
            loading1: false,
            options1: [],
            listGoods: [],
            titleGoods: [
                {
                    title: '商品名称',
                    key: 'goodsName',
                },
                {
                    title: '图标',
                    key: 'goodsIcon',
                    slot: 'goodsIcon',
                },
                {
                    title: '商品数量',
                    key: 'goodsCount',
                    slot: 'goodsCount',
                },
                {
                    title: '商品单价',
                    key: 'goodsPrice',
                    slot: 'goodsPrice',
                },
                {
                    title: '合计单价',
                    key: 'totalPrice',
                    slot: 'totalPrice',
                },

                { key: 'operater', title: '操作', slot: 'operater' },
            ],
            useRecord: [],
            useRecordData: {},
            modalRuleTypeIndex: -1,
            evoCode: '',
            qrCode: '',
            evoData: '',
            modalConfirmPickUpGoods: false, //确认收货是否弹窗
            dyOrderid: '',
        };
    },
    watch: {
        ['writeOffData.movieRule'](list) {
            let tableLength = list.length == 0;
            //字段必须勾选
            if (tableLength == 0) {
                this.writeOffData.movieRuleElse = true;
            }
        },
    },
    computed: {
        cpTotalPrice() {
            try {
                let data = this.writeOffData.movieCount * this.writeOffData.moviePrice;
                for (let i = 0; i < this.writeOffData.goodsList.length; i++) {
                    data += this.writeOffData.goodsList[i].goodsCount * this.writeOffData.goodsList[i].goodsPrice;
                }
                return isNaN(data) ? 0 : data;
            } catch (e) {
                /* handle error */
                return 0;
            }
        },
        cpMv() {
            try {
                let data = this.writeOffData.movieCount * this.writeOffData.moviePrice;

                return isNaN(data) ? 0 : data;
            } catch (e) {
                /* handle error */
                return 0;
            }
        },
        cpGoods() {
            try {
                let data = 0;
                for (let i = 0; i < this.writeOffData.goodsList.length; i++) {
                    data += this.writeOffData.goodsList[i].goodsCount * this.writeOffData.goodsList[i].goodsPrice;
                }
                return data;
            } catch (e) {
                /* handle error */
                return 0;
            }
        },
    },
    created() {
        this.fetTableShopping();
    },
    methods: {
        /**
         * 确认EOV取货码取货
         */
        async confirmPickUpGoods() {
            let res = await ConfirmEovCode({
                product_orderid: this.evoData.product_orderid,
                qrCode: this.evoData.qrCode,
            });
            if (res.errcode != 0) return;
            //刷新当前取货查询信息
            this.searchEVO(this.evoData.qrCode);
        },
        /**
         * 查询EVO取货
         */
        async searchEVO(evoCode) {
            let res = await QueryEovCodeInfo({ qrCode: this.evoCode || evoCode });
            if (res.errcode != 0) return;
            this.evoData = res.data;
            this.evoCode = '';
        },
        async add2DatesFromhHoliday() {
            let res = await OperationHoliday({ exeType: '获取列表', page: 1, all: true });
            if (res.errcode != 0) return;
            let list = res.data.list.map((item) => {
                return { date: item.day };
            });
            this.formRuleType.dateList.push(...list);
        },
        /**
         * 电影票添加规则表格数据
         */
        editRuleAdd(row, index) {
            this.formRuleType = JSON.parse(JSON.stringify(row));
            if (row.ruleType == 'week') {
                this.formRuleType.week = row.weekList;
            }
            if (row.format == 'datetime') {
                this.formRuleType.startTime1 = new Date(row.startTime);
                this.formRuleType.endTime1 = new Date(row.endTime);
            }
            if (row.ruleType == 'movie') {
                this.options2 = row.movieList.map((item) => {
                    return {
                        label: item.movieName,
                        value: item.movieCode,
                    };
                });
                this.formRuleType.movieList = row.movieList.map((item) => {
                    return item.movieCode;
                });
                this.formRuleType = JSON.parse(JSON.stringify(this.formRuleType));
            }
            if (row.format == 'dates') {
                let list = row.dateList.map((item) => {
                    return { date: item };
                });
                this.formRuleType.dateList = Array.from(new Set(list));
            }
            if (row.ruleType == 'hall') {
                this.formRuleType.hall = row.hallCodeList;
            }
            if (row.ruleType == 'week') {
                this.formRuleType.week = row.weekList;
            }
            this.modalRuleTypeIndex = index;
            this.modalRuleType = '编辑';
            this.modalRuleAdd = true;
        },
        removeSpacelDate(tableIndex) {
            this.formRuleType.dateList = this.formRuleType.dateList.filter((item, index) => tableIndex != index);
        },
        add2Dates() {
            this.formRuleType.dateList.push({ date: moment(this.formRuleType.dates).format('yyyy-MM-DD') });
        },
        remoteMethod2(query) {
            debugger;
            if (query !== '') {
                this.loading2 = true;
                setTimeout(async () => {
                    this.options2 = [];
                    this.loading2 = false;
                    let passdata = {
                        year: new Date().getFullYear() + '',
                        name: query,
                    };
                    const instance = axios.create({
                        baseURL: 'https://gzxh.ruiziyou.com/conf/film/queryFilmsOption',
                        timeout: 5000,
                        method: 'POST',
                    });
                    let res = await instance.post('', passdata);
                    let list = res.data.data;
                    list = list.filter((item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    for (let i = 0; i < list.length; i++) {
                        let count = this.options2.filter((item) => item.value.toLowerCase().indexOf(list[i].value.toLowerCase()) == -1);

                        //没有的数据筛入配置项里面
                        if (count) {
                            this.options2.push(list[i]);
                        }
                    }
                }, 200);
            } else {
                this.options2 = [];
            }
        },

        /**
         * 删除添加规则弹窗保存后的本地数据
         */
        deleteRuleAdd(tableIndex) {
            let data = this.writeOffData.movieRule.filter((item, index) => index != tableIndex);
            this.writeOffData.movieRule = data;
        },
        /**
         * 添加规则弹窗确认后保存到本地表格
         */
        confirmModalRuleAdd() {
            let data = {
                weight: this.formRuleType.weight,
                isExchange: this.formRuleType.isExchange ? true : false,
                ruleType: this.formRuleType.ruleType,
            };
            if (this.formRuleType.ruleType == 'movie') {
                let list = this.options2
                    .filter((item) => this.formRuleType.movieList.find((item1) => item1 == item.value))
                    .map((item) => {
                        return { movieCode: item.value, movieName: item.label };
                    });
                data['movieList'] = list;
            }
            if (this.formRuleType.ruleType == 'week') {
                data['weekList'] = this.formRuleType.week;
            }
            if (this.formRuleType.ruleType == 'hall') {
                data['hallCodeList'] = this.formRuleType.hall;
            }
            if (this.formRuleType.ruleType == 'time' && this.formRuleType.format == 'datetime') {
                if (!this.formRuleType.startTime1 || !this.formRuleType.endTime1) {
                    return;
                }
                if (this.formRuleType.startTime1) {
                    data['startTime'] = moment(this.formRuleType.startTime1).format('yyyy-MM-DD HH:mm:ss');
                }
                if (this.formRuleType.endTime1) {
                    data['endTime'] = moment(this.formRuleType.endTime1).format('yyyy-MM-DD HH:mm:ss');
                }
                data['format'] = 'datetime';
            }
            if (this.formRuleType.ruleType == 'time' && this.formRuleType.format == 'time') {
                data['startTime'] = this.formRuleType.startTime;
                data['endTime'] = this.formRuleType.endTime;
                data['format'] = 'time';
            }
            if (this.formRuleType.ruleType == 'time' && this.formRuleType.format == 'dates') {
                data['dateList'] = this.formRuleType.dateList.map((item) => item.date);
                data['format'] = 'dates';
            }
            if (this.modalRuleType == '编辑') {
                let list = JSON.parse(JSON.stringify(this.writeOffData.movieRule));
                list[this.modalRuleTypeIndex] = data;
                this.writeOffData.movieRule = list;
            }
            if (this.modalRuleType == '新增') {
                this.writeOffData.movieRule.push(data);
            }
            this.hideMe('modalRuleAdd');
        },
        /**
         * 获取添加规则本地的数据
         */
        async fetchRuleTypeListConfig() {
            let res = await GetPresetValue({ type: '抖音核销工具-电影兑换-规则类型' });
            if (res.errcode != 0) return;
            this.ruleTypeList = res.data;
        },
        /**
         * 弹窗添加规则
         */
        async showModalRuleAdd() {
            this.modalRuleType = '新增';
            await this.fetchRuleTypeListConfig();
            this.modalRuleAdd = true;
        },
        changeUseRecodeDatePicker(value) {
            this.useRecord = value;
        },
        /**
         * 在线和小记录查询
         */
        async searchUseRecord(page = 1, size = 10) {
            if (!this.useRecord[0] && !this.useRecord[1]) {
                this.$Message.warning('请填写查询条件');
                return;
            }
            let res = await GetDyVerifRecord({
                startTime: this.useRecord[0], //开始时间
                endTime: this.useRecord[1], //结束时间
                page, //分页页码，数字类型
                size,
                dyOrderid: this.dyOrderid,
            });
            if (res.errcode != 0) return;
            res.data.title = [
                ...res.data.title,
                {
                    key: 'operater',
                    title: '操作',
                    slot: 'operater',
                },
            ];
            this.useRecordData = res.data;
        },
        /**
         * 删除插入行的数据
         */
        removeInsetTableRow2(index) {
            this.writeOffData.goodsList.splice(index, 1);
        },
        add2GoodsList() {
            this.writeOffData.goodsList.push(JSON.parse(JSON.stringify(this.model13)));
        },
        async remoteMethod1(query) {
            if (query !== '') {
                this.loading1 = true;
                let res = await GetDyVerifGoodsList({ keywords: query });
                this.listGoods = res.data;
                setTimeout(() => {
                    this.loading1 = false;
                    const list = this.listGoods.map((item) => {
                        return {
                            value: item.goodsId,
                            label: item.goodsName,
                            ...item,
                        };
                    });
                    this.options1 = list.filter((item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                }, 200);
            } else {
                this.options1 = [];
            }
        },
        hideMe(value) {
            if (value == 'modalRuleAdd') {
                this.modalRuleAdd = false;
                this.formRuleType = {
                    weight: '1',
                    isExchange: '',
                    ruleType: '',
                    week: [],
                    hall: [],
                    format: '',
                    startTime: '',
                    startTime1: '',
                    endTime: '',
                    endTime1: '',
                    dateList: [],
                    dates: '',
                    movieList: [],
                };
                return;
            }
            this.dyWriteOffModal = false;
        },
        async confirmWriteOff() {
            //TODO 提交抖音核销表单数据
            let writeOffData = JSON.parse(JSON.stringify(this.writeOffData));
            writeOffData.goodsList = writeOffData.goodsList.map((item) => {
                return {
                    goodsCount: item.goodsCount,
                    goodsIcon: item.goodsIcon,
                    goodsId: item.goodsId,
                    goodsName: item.goodsName,
                    goodsPrice: item.goodsPrice,
                };
            });
            let passdata = {
                remoteMapId: this.writeOffData.remoteMapId,
                rule: {
                    movieCount: writeOffData.movieCount, //电影票兑换量
                    movieRule: writeOffData.movieRule, //电影票兑换规则
                    movieRuleElse: writeOffData.movieRuleElse, //未命中规则是否全部允许兑换
                    goodsExchange: writeOffData.goodsExchange, //卖品套餐兑换方式
                    goodsList: writeOffData.goodsList, //卖品套餐兑换列表
                    status: writeOffData.status, //是否开启规则
                    recordVersion: writeOffData.__v, //当前版本
                    moviePrice: this.writeOffData.moviePrice,
                },
            };
            let res = await SetDyVerifRule(passdata);
            if (res.errcode != 0) return;
            this.fetTableShopping();
            this.hideMe();
        },
        handleWriteOff() {},
        async dyWriteOff(type, id) {
            await this.fetchRuleTypeListConfig();
            let res = await GetDyVerifRule({ remoteMapId: id });
            if (res.errcode != 0) return;
            res.data.updatedAt = moment(res.data.updatedAt).format('yyyy-MM-DD HH:mm:ss');
            this.writeOffData = res.data;
            this.dyWriteOffModal = true;
            // if(type=='未配制'){}
            // if(type=='已配制'){}
        },
        /**
         * 显示抖音表格添加弹窗
         */
        showdyModalAdd() {
            this.dyTableUploadModal = true;
            this.$refs['uploadForm'].resetFields();
        },
        /**
         * 抖音导入添加一行表格数据
         */
        async confirmAddTableRow() {
            this.$refs['uploadForm'].validate(async (valid) => {
                if (valid) {
                    //预校验数据
                    await this.preUpload(this.uploadForm);
                    // 数据下方到表格下
                    if (this.uploadForm['exeType'] != '导入异常') {
                        this.xlslTableList.unshift(JSON.parse(JSON.stringify(this.uploadForm)));
                        this.dyTableUploadModal = false;
                    }
                }
            });
        },
        async downTemplate() {
            let res = await GetPresetValue({ type: '抖音导入模板' });
            if (res.errcode != 0) return;
            var a = document.createElement('a'); //创建一个a标签 用来下载
            a.download = '抖音导入模板'; //设置下载的图片名称
            var event = new MouseEvent('click'); //增加一个点击事件
            //如果需要下载的话就加上这两句
            a.href = res.data; //此处的url为base64格式的图片资源
            a.dispatchEvent(event); //触发a的单击事件 即可完成下载
        },
        /**
         * 刷新表格
         */
        reloadTableUpload() {
            this.xlslTableList = JSON.parse(JSON.stringify(this.xlslTableList));
        },
        /**
         * 预校验单挑
         */
        async preUpload(data) {
            let { sku_id } = data;
            let res = await CheckmanualEdit({ sku_id });
            if (res.errcode == 0) {
                //正常返回
                if (res.data == 1) {
                    data['exeType'] = '创建';
                }
                if (res.data == 2) {
                    data['exeType'] = '编辑';
                }
            } else {
                //  报错返回
                data['exeType'] = '导入异常';
            }
        },
        /**
         * 欲校验确认上传
         */
        async preUploadTableData() {
            let list = this.xlslTableList;
            for (let i = 0; i < list.length; i++) {
                await this.preUpload(list[i]);
            }
            this.reloadTableUpload();
        },
        /**
         *  确认上传按钮
         */
        async uploadTableData() {
            let list = this.xlslTableList;
            for (let i = 0; i < list.length; i++) {
                let data = list[i];
                if (data['exeType'] != '导入异常') {
                    let passdata = JSON.parse(JSON.stringify(data));
                    try {
                        passdata['start_time'] = passdata['start_time'].split('.').join('-').replaceAll('/', '-');
                        passdata['end_time'] = passdata['end_time'].split('.').join('-').replaceAll('/', '-');
                        passdata['use_end_time'] = passdata['use_end_time'].split('.').join('-').replaceAll('/', '-');
                        passdata['use_start_time'] = passdata['use_start_time'].split('.').join('-').replaceAll('/', '-');
                    } catch (error) {
                        this.$Message.error(error.message);
                    }
                    let res = await ManualEdit(passdata);
                    if (res.errcode == 0) {
                        data['result'] = '成功';
                    } else {
                        data['result'] = '失败';
                        console.log(data);
                    }
                }
            }
            this.reloadTableUpload();
        },
        async handleUpload(file) {
            //构建映射表
            let tableMap = {
                '使用时间(开始)': 'use_start_time',
                '使用时间(结束)': 'use_end_time',
                '售卖时间(开始)': 'start_time',
                '售卖时间(结束)': 'end_time',
                商品ID: 'sku_id',
                商品名称: 'sku_name',
            };
            let res = await readXls2Json(file);
            let tableList = [];
            //处理表格数据
            res.forEach((item, index) => {
                let tabelRow = {};
                for (let key in item) {
                    let realKey = tableMap[key];
                    let value = item[key];
                    //过滤undefined
                    if (realKey) {
                        tabelRow[realKey] = value;

                        //处理当前是日期格式的数据
                        if (typeof value == 'object') {
                            tabelRow[realKey] = new Date(value).Format('yyyy.MM.dd');
                        }
                    }
                    //追加表头数据 字段
                }
                console.log(12312);
                tableList.push(tabelRow);
            });
            console.log(tableList);
            this.xlslTableList = tableList.slice(0, 20);
            this.preUploadTableData();
            return false;
        },
        /**
         * 提交同步数据弹窗内容
         */
        async confirmSomeModal() {
            this.$refs['someModalref'].validate(async (valid) => {
                if (valid) {
                    const { select, product_id } = this.someModalForm;
                    //同步全部上线商品  选中 调用 tobesome
                    if (select == '同步全部上线商品') {
                        try {
                            await this.toBeSome();
                            this.someModal = false;
                        } catch (error) {}
                    }
                    if (select == '同步单个商品') {
                        let res = await GetTiktokShop({ product_id });
                        if (res.errcode != 0) return;
                    }

                    this.fetTableShopping();
                }
            });
        },
        /**
         * 取消同步数据弹窗
         */
        cancelSomeModal() {
            this.someModal = false;
        },
        /**
         * 显示同步数据弹窗
         */
        showSomeModal() {
            this.someModal = true;
            this.$refs['someModalref'].resetFields();
        },
        /**
         * 撤销按钮 点击
         */
        async handleBackupBtn(value) {
            this.currentTableRow = value;
            this.backupModel = true;
            this.$refs['backupForm'].resetFields();
        },
        /**
         * 撤销记录撤销 提交
         */
        async confirmBackUp() {
            this.$refs['backupForm'].validate(async (valid) => {
                console.log(valid);
                if (valid) {
                    const { _id } = this.currentTableRow;
                    let res = await RevokeCash({
                        id: _id,
                        ...this.backupForm,
                    });
                    if (res.errcode != 0) return;
                    this.backupModel = false;
                    this.fetchPayCodeTableData();
                }
            });
        },
        /**
         * 关闭撤销弹窗
         */
        cancelBackUpModal() {
            this.backupModel = false;
        },
        /**
         * 跳转核销详情页面
         */
        openWindow(id) {
            window.open('/payCodeDetail?id=' + id);
        },
        /**
         * 切换tabs
         */
        changeTab(value) {
            if (value == '抖音团购') {
                this.fetTableShopping();
            }
            if (value == '微信核销记录') {
                this.fetchPayCodeTableData();
            }
            if (value == '抖音在线核销记录') {
                //设置查询查询条件 开始日期-结束条件
                //默认初始值当天6点到次日6点
                this.useRecord = [moment().format('yyyy-MM-DD') + ' 06:00', moment().add(1, 'day').format('yyyy-MM-DD') + ' 06:00'];
                this.searchUseRecord();
            }
        },
        /**
         * 导出所有核销的表格数据
         */
        async exportPayCodeTable() {
            let data = Object.assign({}, this.formPayCode);
            data['page'] = 1;
            data['all'] = true;
            let res = await GetGoosCashRecordList(data);
            if (res.errcode != 0) return;
            const { list, title } = res.data;
            data = list;
            download({
                worksheet: '核销',
                headers: title,
                data,
            });
        },
        /**
         * 查询核销的表格数据
         */
        async fetchPayCodeTableData(page = 1) {
            let data = Object.assign({}, this.formPayCode);
            data['page'] = page;
            data['all'] = false;
            let res = await GetGoosCashRecordList(data);
            if (res.errcode != 0) return;
            res.data.title.push({
                slot: 'opreate',
                title: '操作',
                key: 'opreate',
            });
            res.data.title.forEach((item, index) => {
                if (item.key == 'isRelieve_res') {
                    item['slot'] = 'isRelieve_res';
                }
                if (item.key == 'revoke') {
                    item['slot'] = 'revoke';
                }
            });
            this.payCodeTableData = res.data;
        },
        /**
         * 删除插入行的数据
         */
        removeInsetTableRow(index) {
            this.currentTableRow.givList.splice(index, 1);
        },
        /**
         * 执行插入数据到表格动作
         */
        insetTableData() {
            const { value1, value2, value3 } = this.formPreset;
            const { value: id, label: Name } = this.presetValue.filter((item, index) => item.value == value1)[0];
            let data = {
                type: '票券',
                id: id,
                Num: value2, //兑换量1-99
                Time: value3, //有效期 0使用模板 1为绑定后起1天
                Name: Name, //票券名称
            };
            this.currentTableRow.givList.push(data);
            this.$refs['formPreset'].resetFields();
        },
        /**
         * 插入表格预设值 获取
         */
        async handleGetPresetValue() {
            let res = await GetPresetValue({ type: '获取非赠券' });
            if (res.errcode != 0) return false;
            this.presetValue = res.data;
            return true;
        },
        /**
         * 取消 设置 弹窗
         */
        cancelSettingModal() {
            this.settingModel = false;
        },
        /**
         * 提交 设置 弹窗
         */
        async confimSettingModal() {
            const { _id, givList } = this.currentTableRow;
            let data = {
                exeType: '设置兑换表',
                id: _id,
                givList: givList,
            };
            let res = await ExeDyGoos(data);
            if (res.errcode != 0) return;
            this.fetTableShopping(this.tableShoppingData.page, this.name);
            this.settingModel = false;
        },
        /**
         * 获取表格行详情数据
         */
        async getTableRowData(id) {
            let res = await ExeDyGoos({ exeType: '获取详情', id });
            if (res.errcode != 0) return false;
            this.currentTableRow = res.data;
        },
        /**
         * 弹窗 当前表格行数据
         */
        showSettingModel(value) {
            const { _id } = value;
            this.handleGetPresetValue();
            this.$refs['formPreset'].resetFields();
            let access = this.getTableRowData(_id);
            if (access == false) return;
            this.settingModel = true;
        },
        /**
         * 核销 切换
         * @param {*} id 商品id
         * @param {*} value 切换的值 boll
         */
        async destoryCode(id, value) {
            await ExeDyGoos({
                exeType: '允许核销',
                id: id,
                openCash: value,
            });
            this.fetTableShopping(this.tableShoppingData.page, this.name);
        },
        /**
         * 同步商品
         */
        async toBeSome() {
            let res = await GetTiktokShopList({});
            if (res.errcode != 0) return;
            this.$Message.success('同步成功');
            this.fetTableShopping(this.tableShoppingData.page, this.name);
        },
        /**
         * 表格获取 团购商品
         */
        async fetTableShopping(page = 1, name = '') {
            let res = await GetDyGoosList({ name, page, isuseTime: this.isuseTime });
            if (res.errcode != 0) return;
            res.data.title.forEach((item, index) => {
                if (item.key == 'openCash') {
                    item['slot'] = 'openCash';
                }
                if (item.key == 'givList') {
                    item['slot'] = 'givList';
                }
                if (item.key == 'online_status') {
                    item['slot'] = 'online_status';
                    item['width'] = 150;
                }
                if (item.key == 'Note') {
                    item['slot'] = 'Note';
                }
                if (item.key == 'isConfigVerifRule') {
                    item['slot'] = 'isConfigVerifRule';
                }
            });
            this.tableShoppingData = res.data;
        },
        /**
         * 路由跳转
         */
        routeTo(value) {
            window.open(value);
        },
    },
    components: { FormItem, Input, Checkbox },
};
</script>
